import useText from '@/hooks/useText';
import { FeatureCard } from '../AboutDISGENET';
import { useFoundationCards } from '../AboutDISGENET/helpers';

const WHY_DISGENET_VIDEO_SRC = '/static/images/DisgenetKeyVisual1920x1080.mp4';

export default function HomeKnowledgeSection() {
  const eyebrow = useText('home.why_disgenet.label');
  const titlePrefix = useText('home.why_disgenet.title');
  const titleHighlight = useText('home.why_disgenet.title_highlight');
  const titleSuffix = useText('home.why_disgenet.title_suffix');
  const cards = useFoundationCards();

  return (
    <section
      id="features"
      className="home-section home-section-light home-section-with-video-bg scroll-reveal scroll-reveal-stagger"
    >
      <video
        className="why-disgenet-video-bg"
        autoPlay
        loop
        muted
        playsInline
        aria-hidden
        src={WHY_DISGENET_VIDEO_SRC}
      />
      <div className="why-disgenet-video-overlay" aria-hidden />
      <div className="home-section-inner">
        <div className="text-center">
          <p className="home-hero-eyebrow">{eyebrow}</p>
          <h2 className="home-section-title home-section-title-center">
            {titlePrefix}
            <span className="home-hero-highlight">{titleHighlight}</span>
            {titleSuffix}
          </h2>
        </div>
        <div className="home-cards-grid">
          {cards.map((card, i) => (
            <FeatureCard
              key={card.title}
              title={card.title}
              points={card.points}
              badgeText={card.badgeText}
              icon={card.icon}
              index={i}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
